import { HttpClient, HttpParams } from '@angular/common/http';
import { first, map, Observable } from 'rxjs';
import { Pagination } from 'src/app/shared/interfaces/pagination';
import { ResponseApi } from 'src/app/shared/interfaces/response-api';

export abstract class ResponseApiHelper<T> {

  constructor    (
     protected httpClient: HttpClient
  ) { }

  genericGet(url: string, dataType: string, params: HttpParams, pagination: Pagination<T>): Observable<Pagination<T>> {
    return this.httpClient.get<ResponseApi<T>>(url, { params }).pipe(
      first(),
      map((response) => {
        const data = response.data[dataType] ?? [];
        pagination.results = data;
        pagination.total = response.meta.totalRecords;
        pagination.totalPages = response.meta.totalPages;

        return pagination;
      })
    )
  }

}
